/**
 * A paleta de comandos e a dica flutuante — as duas contas por trás.
 *
 * ═══ A BUSCA IGNORA ACENTO ═══
 *
 * "inteligencia" tem que achar "Inteligência". Numa interface em
 * português isso não é conforto: é a diferença entre a busca funcionar e
 * não funcionar, porque ninguém digita acento quando está com pressa —
 * e a tela mais buscada do software tem dois.
 *
 * ═══ A DICA NÃO PODE VAZAR DA JANELA ═══
 *
 * Ela aparece acima do elemento. Perto do topo, não cabe: vai para
 * baixo. Perto da borda, escapa: encosta na margem. Sem essas duas
 * contas, a dica do primeiro item do menu fica cortada pela borda de
 * cima — e a do último botão da direita sai da tela.
 */

/** Sem acento e em minúsculas, para comparar. */
export function semAcento(s: string): string {
  return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
}

export interface ItemDaPaleta {
  rota: string
  nome: string
  dica: string
}

/**
 * Os itens que casam com o que foi digitado.
 *
 * Busca vazia devolve tudo: a paleta aberta sem digitar nada é um menu,
 * e menu vazio não serve para nada.
 */
export function filtrar(itens: ItemDaPaleta[], busca: string): ItemDaPaleta[] {
  const b = semAcento(busca.trim())
  if (!b) return itens
  return itens.filter(i =>
    semAcento(i.nome).includes(b) || semAcento(i.dica).includes(b))
}

/**
 * Onde parar a seleção ao andar com as setas.
 *
 * Dá a volta: da última para a primeira. Numa lista de dez telas, chegar
 * ao fim e a seta parar de responder faz parecer travado.
 */
export function andar(atual: number, quantos: number, passo: number): number {
  if (quantos <= 0) return 0
  return ((atual + passo) % quantos + quantos) % quantos
}

export interface Retangulo {
  top: number
  bottom: number
  left: number
  width: number
}

/** Onde desenhar a dica, em pixels da janela. */
export function posicaoDaDica(
  alvo: Retangulo,
  dica: { largura: number, altura: number },
  janela: { largura: number, altura: number },
  margem = 8,
): { topo: number, esquerda: number, embaixo: boolean } {
  // acima do elemento; se não couber, embaixo
  let topo = alvo.top - dica.altura - margem
  let embaixo = false
  if (topo < margem) { topo = alvo.bottom + margem; embaixo = true }

  // centralizada, mas sem vazar pelas laterais
  let esquerda = alvo.left + alvo.width / 2 - dica.largura / 2
  esquerda = Math.max(margem,
    Math.min(esquerda, janela.largura - dica.largura - margem))

  return { topo, esquerda, embaixo }
}
